jQuery(function($){
	$(document).ready(function(e){
		const checkMenuLoaded = setInterval(function(){
			if( $('.image-banner-menu').length > 0 ) {
				clearInterval(checkMenuLoaded);
				$('.image-banner-menu').each(function(e) {
					$(this).find("img").wrap( "<div class='img-wrap'></div>" )
				});
			}
		}, 100);

        const checkYotpoRewardOpened = setInterval(function(){
			if( $('#yotpo-drawer-layout').css('display') == 'block' ) {
				$('.yotpo-widget-loyalty-floater-widget').addClass('YotpoRewardOpened');
			} else {
              $('.yotpo-widget-loyalty-floater-widget').removeClass('YotpoRewardOpened');
            }
		}, 100);
		
		const checkMenuTitleLoaded = setInterval(function(){
			if( $('.gm-item a[title]').length > 0 ) {
				clearInterval(checkMenuTitleLoaded);
				$(".gm-item a[title]").each(function(e) {
					var thisTitle = $(this).attr('title');
					$(this).attr('aria-label',thisTitle);
					$(this).removeAttr("title");
				});
              
			}
		}, 100);

      $('.mobile-trigger-sort').click(function(){
          $(this).toggleClass("opened");
      })
       $('a.popup-img').click(function(e){
          e.preventDefault();
          var clickedUrl = $(this).attr('href');
          // Simulate a mouse click:
          $(this).closest('.popup-content').find('a.popup-close').addClass('clicked');
          document.querySelector('a.popup-close.clicked').dispatchEvent(new Event('click'));
          window.location.href = clickedUrl;
      })

      $(document).on('click', '.random_trigger_img', function(e){
          e.preventDefault();
          var popupID = $(this).attr('data-popup-id');
          // Simulate a mouse click:
          if( $('.'+popupID).hasClass('random-popup-modal-hidden') ) {
            $('.'+popupID).removeClass("random-popup-modal-hidden");
          } else {
            $('.'+popupID).addClass("visible");
          }
      })
      $(document).on('click', '.random-popup-modal .popup-outer', function(e){
        $('.random-popup-modal').removeClass("visible");
       })
      $(document).on('click', '.random-popup-modal .popup-inner:not(.popup-content)', function(e){
        $('.random-popup-modal').removeClass("visible");
      })
      /*
      $(".page-frame-section").load('https://sukin.searchbrown.com/earth/', function( response, status, xhr ) {
        $(".page-frame-section").append(response);
      });*/

      $(".pageIframes").each(function(){
			  $('#'+$(this).attr('id')).on('load', function () {
          $('.iframe-loading-img').fadeOut('slow');
        });
			  iFrameResize({ log: false, autoResize:true, inPageLinks: true }, '#'+$(this).attr('id'))
		  })

      let options = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: 'Australia/Sydney'
      };
      var dateToday = new Date().toLocaleString('en', options);
      const dateCurrentTime = new Date(dateToday);
      const datecurrentHour = dateCurrentTime.getHours();
      const datecurrentMinutes = dateCurrentTime.getMinutes();
      const dayOfWeekIndex = dateCurrentTime.getDay();
      const timestamp = dateCurrentTime.getTime();
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const dayName = days[dayOfWeekIndex];
      
      
      if( $('.schedule-popup').length > 0 ) {
        $('.schedule-popup').each(function(){
          let scheduled_days = $(this).attr('data-s-days');
          let scheduled_shour = parseInt( $(this).attr('data-s-shour') );
          let scheduled_smin = parseInt( $(this).attr('data-s-smin') );
          let scheduled_sampm = $(this).attr('data-s-sampm');
          let scheduled_ehour = parseInt( $(this).attr('data-s-ehour') );
          let scheduled_emin = parseInt( $(this).attr('data-s-emin') );
          let scheduled_eampm = $(this).attr('data-s-eampm');
          let scheduled_days_array = scheduled_days.split(',');
          
          if ( scheduled_sampm == "PM" && scheduled_shour < 12 ) {
            scheduled_shour += 12;
          } else if ( scheduled_sampm == "AM" && scheduled_shour === 12 ) {
            scheduled_shour = scheduled_shour;
          }
          if ( scheduled_eampm == "PM" && scheduled_ehour < 12 ) {
            scheduled_ehour += 12;
          } else if ( scheduled_sampm == "AM" && scheduled_ehour === 12 ) {
            scheduled_ehour = scheduled_ehour;
          }

          var dateSchedule = new Date().toLocaleString('en', options);
          const dateScheduleSTime = new Date(dateSchedule);
          const dateScheduleETime = new Date(dateSchedule);

          dateScheduleSTime.setHours(scheduled_shour, scheduled_smin, 0, 0);
          var timestampMSs = dateScheduleSTime.getTime();

          dateScheduleETime.setHours(scheduled_ehour, scheduled_emin, 0, 0);
          var timestampMEs = dateScheduleETime.getTime(); 

          console.log(timestampMSs);
          console.log(timestampMEs);

          if ($.inArray(dayName, scheduled_days_array ) !== -1) {
            if( timestampMSs <= timestamp && timestampMEs >= timestamp ) {
              console.log("Value exists in array!");
              $(this).removeClass('hidden-visible');
            } else {
              console.log("Value not exists in array!");
              $(this).addClass('hidden-visible');
              $(this).removeClass('visible');
              if( $('.popup.visible').length < 1 ) {
                //$('body').removeClass('active-popup');
              }
            }
          } else {
            console.log("Value not exists in array 1!");
            $(this).addClass('hidden-visible');
            $(this).removeClass('visible');
            if( $('.popup.visible').length < 1 ) {
              //$('body').removeClass('active-popup');
            }
          }
          console.log(scheduled_days);
        })
      }
      
      /*console.log(dayName);
      console.log(datecurrentHour);
      console.log(datecurrentMinutes);
      console.log(timestamp);*/

      document.querySelectorAll('.add-to-bag').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.classList.add('adding-to-cart-button');
      });
    });

    document.addEventListener("cart:sending", (event) => {
      document.querySelectorAll('.add-to-bag.adding-to-cart-button').forEach((btn) => {
        console.log(`cart:sending`);
        const spinner = btn.querySelector('.spinner');
        spinner.hidden = false;          // show spinner next to text
      });
    });

    document.addEventListener('cart:itemAdded', () => {
      document.querySelectorAll('.add-to-bag').forEach((btn) => {
        btn.querySelector('.spinner').hidden = true;
        btn.classList.remove('adding-to-cart-button');
      });
    });

    document.addEventListener('cart:updated', () => {
      console.log('cart:updated');
      updateCartDiscountDOM();
    });

    function updateCartDiscountDOM() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const totalDiscountCents = cart.total_discount;
          
          // 1. Locate the main wrapper element
          const discountWrapper = document.getElementById('cart-total-discounts-container');
          const discountValueSpan = discountWrapper ? discountWrapper.querySelector('.cart-total-discount-price') : null;

          if (discountWrapper && discountValueSpan) {
            // 2. Hide the div completely if the discount is 0
            if (totalDiscountCents === 0) {
              console.log('0');
              discountWrapper.style.display = 'none';
            } else {
              console.log('more than 0');
              // 3. Show the div and update the text if a discount exists
              const decimalDiscount = (totalDiscountCents / 100).toFixed(2);
              discountValueSpan.textContent = `$${decimalDiscount}`;
              discountWrapper.style.display = 'block'; // or 'flex' depending on your CSS
            }
          }
        })
        .catch(error => console.error('Error fetching Shopify cart:', error));
    }


  })

})